import SVG from 'react-inlinesvg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const Wrapper = styled.div<{ isSmallScreen: boolean }>`
  max-width: ${({ isSmallScreen }) => (isSmallScreen ? '200px' : '250px')};
  font-size: 0;

  svg {
    height: 60px;
    max-height: 100%;
    width: auto;
  }
`;

function LogoWhite() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Wrapper isSmallScreen={isSmallScreen}>
      <SVG src="/media/brand/logo-white.svg" />
    </Wrapper>
  );
}

export default LogoWhite;
